import React from 'react'

import { CompanyLifecycle } from '@/gen/inventory/v1/company_lifecycle_pb'

import { companyLifecycleLabel } from '@/const/label'

import { cn } from '@/lib/ui/style-helpers'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'

type CompanyLifecycleBadgeProps = {
  lifecycle: CompanyLifecycle
} & BadgeProps

export const CompanyLifecycleBadge = React.forwardRef<HTMLDivElement, CompanyLifecycleBadgeProps>(
  ({ lifecycle, className, variant, badgeStyle, ...props }, ref) => {
    const isUnsanctioned = lifecycle === CompanyLifecycle.UNSANCTIONED
    const effectiveVariant = variant ?? (isUnsanctioned ? 'danger' : 'neutral')
    const effectiveBadgeStyle = badgeStyle ?? (isUnsanctioned ? 'subtle' : undefined)

    return (
      <Badge
        ref={ref}
        variant={effectiveVariant}
        badgeStyle={effectiveBadgeStyle}
        textCase='title'
        className={cn(className, 'gap-1 text-nowrap')}
        {...props}
      >
        {companyLifecycleLabel[lifecycle]}
      </Badge>
    )
  },
)
CompanyLifecycleBadge.displayName = 'CompanyLifecycleBadge'
